import { SpinnerIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const EmailTemplateListLoadingState: FC = () => {
  const { t } = useTranslation('campaign');

  return (
    <div className='bg-white flex flex-col items-center justify-center gap-3 rounded-2xl border border-secondary-border p-8'>
      <SpinnerIcon className='text-primary-600 size-5' />
      <p className='text-secondary-600 text-sm'>{t('emailWorkspace.templates.loadingTemplates')}</p>
    </div>
  );
};
